export function gaVisitorId(): string | null {
  if (typeof window === "undefined") {
    return null;
  }

  const cookieName = "_ga";
  const cookie = document.cookie.split(";").find((c) => c.trim().startsWith(cookieName + "="));
  if (!cookie) {
    return null;
  }

  const cookieValue = cookie.split("=")[1];
  if (!cookieValue) {
    return null;
  }

  // Return the full GA client ID including the GA1.X prefix
  // Format: GA1.2.XXXXXXXXX.YYYYYYYYYY
  // The full ID is required by GA4 Measurement Protocol
  return cookieValue;
}
